import React from 'react'
import { useState } from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import DealOfTheWeek from '../DealOfTheWeek/DealOfTheWeek'
const DealCarousel = () => {
    const [sliderRef, setSliderRef] = useState(null)

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
    }
    return (
        <>
        <div className="offer-bx mt-4">
        <Slider {...sliderSettings}>
            <div>
                    <DealOfTheWeek />
            </div>
            <div>
                    <DealOfTheWeek />
            </div>
        </Slider>
        </div>
        </>
    )
}

export default DealCarousel